module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ezgjq"))).then(() => parcelRequire('d0iPb'));